import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as workspace from '../workspace'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: workspace.RESOURCE.payload.dimension.partialId,
      partialId: workspace.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The timestamp when the workspace was created.',
    isOptional: false,
    name: 'Created At',
    partialId: PartialId.Standard.create('createdAt'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
